import '../../modules/mode-components';

import * as angular from 'angular';
import * as _ from 'lodash';

const removeShortcutSpaceDirective = function (Modal, ModeCollection, AlertService, $log) {
  return {
    restrict: 'A',
    scope: {
      report: '<',
      space: '<',
      onRemove: '&',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.removeShortcut', (event) => {
        $scope.report
          .spaceLinks({ refresh: true })
          .then(ModeCollection.elements)
          .then((spaceLinks) => {
            const spaceLink: any = _.find(spaceLinks, (link: any) => link.space_token === $scope.space.token);
            if (spaceLink) {
              spaceLink.destroy().then(() => {
                AlertService.success('Removed shortcut');
                $scope.onRemove();
              });
            } else {
              AlertService.error('Could not remove shortcut');
            }
          });
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.removeShortcut'));
    },
  };
};

removeShortcutSpaceDirective.$inject = ['ModalService', 'ModeCollection', 'ToastService', '$log'];

angular.module('mode.components').directive('removeShortcutSpace', removeShortcutSpaceDirective);
